// Mirrors spidra-backend/config/crawlLimits.ts: the most pages one crawl may return on each plan. The API enforces
// it; the dashboard uses it to set the Max pages field and explain the limit.
export const CRAWL_PAGE_LIMITS: Record<string, number> = {
  Free: 100,
  Starter: 1_000,
  Builder: 5_000,
  Pro: 10_000,
  Enterprise: 10_000,
};

export const crawlPageLimitFor = (planName?: string | null): number =>
  (planName && CRAWL_PAGE_LIMITS[planName]) || CRAWL_PAGE_LIMITS.Free;
